import React from 'react'
import { Typography } from '../Typography/Typography'
import { Info } from '../../../assets/icons'
import { Button } from '../Button/Button'
import { Dialog } from './Dialog'
import { colors } from '../../../theme/palette'

type SimpleDialogProps = {
    title?: string
    message?: React.ReactNode
    closeDialog: () => void
    icon?: React.ReactNode
    buttonText?: string
    isError?: boolean
}

export const SimpleDialog: React.FC<SimpleDialogProps> = ({
    title = '',
    message = '',
    closeDialog,
    icon,
    buttonText,
    isError,
}) => {
    return (
        <Dialog
            trigger={null}
            defaultOpen
            hideClose
            icon={icon || <Info width="46px" />}
            {...(isError && { iconBGColor: colors.red200 })}
        >
            <Typography
                style={{ marginBottom: '30px' }}
                size="L"
                align="center"
            >
                {title}
            </Typography>
            <Typography
                tag="p"
                size="S"
                style={{ marginBottom: '30px' }}
                align="center"
            >
                {message}
            </Typography>
            <Button
                size="xlarge"
                onClick={closeDialog}
                className="ignore-clickoutside"
            >
                {buttonText || 'OK'}
            </Button>
        </Dialog>
    )
}
